import {Container} from "react-bootstrap";
import React from "react";

export default function ApproveButton(props) {
    return (<>
        <Container fluid className={props.isActionColBtn?"d-none":"m-0 p-0"} style={{cursor:'pointer'}}>
            <a href="#" onClick={props.onApproveButtonClick}>Approve</a>
        </Container>
        <Container fluid className={!props.isActionColBtn?"d-none":"m-0 p-0"}>
            <button className="btn btn-block td-btn-primary-light  my-3" href="#" onClick={props.onDeleteButtonClick}>
                {props.buttonTitle??'Approve'}
            </button>
        </Container>
    </>)
}